import { render, staticRenderFns } from "./CustomNotifications.vue?vue&type=template&id=48b8cf34&scoped=true"
import script from "./CustomNotifications.vue?vue&type=script&lang=js"
export * from "./CustomNotifications.vue?vue&type=script&lang=js"
import style0 from "./CustomNotifications.vue?vue&type=style&index=0&id=48b8cf34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b8cf34",
  null
  
)

export default component.exports